import { px2remTransformer, StyleProvider } from '@ant-design/cssinjs';
import { Font } from '@react-pdf/renderer';
import { ConfigProvider } from 'antd';
import { ReactElement } from 'react';
import { Provider } from 'react-redux';
import { store } from 'src/app/redux/store';
import { NotificationController } from 'src/pages/app/components/notifications/NotificationController';
import { themeAnt } from 'src/shared/styles/themeAnt';
import { AppRouter } from '../../app/router/ui/AppRouter';

// https://ant.design/docs/react/compatible-style#rem-adaptation
const px2rem = px2remTransformer({
	rootValue: 14,
});

export const appDecorator = (Component: ReactElement<any, any>) => (
	<ConfigProvider theme={themeAnt}>
		<StyleProvider transformers={[px2rem]}>
			<Provider store={store}>{Component}</Provider>
		</StyleProvider>
	</ConfigProvider>
);

export const App = () => {
	// * Font register for PDF renderer.
	Font.register({
		family: 'Poppins, sans-serif',
		fonts: [
			{
				src: '/fonts/Poppins-Regular.ttf',
			},
			{
				src: '/fonts/Poppins-Bold.ttf',
				fontWeight: 'bold',
			},
			{
				src: '/fonts/Poppins-Light.ttf',
				fontWeight: 'light',
			},
		],
	});

	Font.register({
		family: 'Montserrat, sans-serif',
		fonts: [
			{
				src: '/fonts/Montserrat-Light.ttf',
				fontWeight: 'light',
			},
			{
				src: '/fonts/Montserrat-Medium.ttf',
				fontWeight: 'medium',
			},
			{
				src: '/fonts/Montserrat-Regular.ttf',
				fontWeight: 'normal',
			},
		],
	});

	Font.register({
		family: 'Ubuntu, sans-serif',
		fonts: [
			{
				src: '/fonts/Ubuntu-Light.ttf',
				fontWeight: 'light',
			},
			{
				src: '/fonts/Ubuntu-Medium.ttf',
				fontWeight: 'medium',
			},
			{
				src: '/fonts/Ubuntu-Regular.ttf',
				fontWeight: 'normal',
			},
		],
	});

	// * Render
	return (
		<>
			{appDecorator(
				<>
					<NotificationController />
					<AppRouter />
				</>,
			)}
		</>
	);
};
